import groupBy from 'lodash/groupBy';

export const sortMessages = <T extends { createdAt?: number }>(
	input: T[],
	convertDate: (args: T) => string = ({ createdAt }) =>
		createdAt ? new Date(createdAt).toDateString() : 'Invalid Date',
): [string, T[]][] => {
	if (!input) {
		return [];
	}
	const sortedInput = [...input].sort((a, b) => {
		if (a.createdAt === undefined || b.createdAt === undefined) {
			return a.createdAt === undefined ? 1 : -1;
		}
		return b.createdAt - a.createdAt;
	});
	const sortedDays = Array.from(new Set(sortedInput.map(convertDate)).values());
	const groupedInput = groupBy(sortedInput, convertDate);
	return sortedDays.map((day) => [day, groupedInput[day]] as [string, T[]]);
};
